import {Component, OnInit} from '@angular/core';
import { ComponentBase } from '../../core/entities/component-base';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';
import { WarehouseService } from '../../services/warehouse.service';
import { Observable } from 'rxjs/Observable';
import { Warehouse, User, ExecutionCounter } from '../../core/entities/entities';
import * as Rx from 'rxjs/Rx';
import { isNullOrUndefined } from 'util';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent extends ComponentBase implements OnInit {

  private _subject: BehaviorSubject<Warehouse[]> = new BehaviorSubject<Warehouse[]>([]);
  public readonly warehouses: Rx.Observable<Warehouse[]> = this._subject.asObservable();

  private _currentWh: Warehouse;

  user: User;

  get currentWarehouse() {
    return this._currentWh;
  }

  private _menus: any = {
    'home': [
      // {
      // translate: 'header.home',
      //   url: '/home/'
      // },
      // {
      //   translate: 'header.movimenti',
      //   url: '/home/movimenti'
      // },
      // {
      //   translate: 'header.vendita',
      //   url: '/home/orders'
      // },
      {
        translate: 'stock-inventory.title',
        url: '/home/stock_inventory'
      },
      {
        translate: 'header.price_rules',
        url: '/home/price_rules'
      }, {
        translate: 'header.stock_rules',
        url: '/home/stock_rules'
      },
    ]
  };
  private _currProfile: string;

  public selectWarehouse(w: Warehouse) {
    this.warehouseService.setWarehouse(w).subscribe();
  }
  get menu(): any[] {
    return this._menus[this.profile];
  }

  get profile(): string {
    return this._currProfile;
  }

  isActiveLink(url: string): boolean {
    return this._router.url === url;
  }

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private warehouseService: WarehouseService)
    {
      super();

    }

  hasProfile(prof: string): boolean {
    return this._authService.hasProfile(prof);
  }

  private loadwarehouses() {
    this._subject.next(this.warehouseService.data.filter(w => !w.refill && !w.virtual && (isNullOrUndefined(this.currentWarehouse) || w.id != this.currentWarehouse.id)));
  }

  ngOnInit() {
    const me = this;
    this._currProfile = this._router.url.split('/').find(path => path && path.trim().length > 0);
    this.warehouseService.dataChange.subscribe(ret => { if (ret) { me.loadwarehouses(); } });
    this.warehouseService.warehouseChange.subscribe(w => {
      if (w) {
        this._currentWh = w;
        this.loadwarehouses();
      }
    });
    this.initializeUser();
  }

  logout() {
    this._router.navigateByUrl('/auth/logout');
  }

  initializeUser(){

    this.user = this._authService.getUser();
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.component.ts